import React from 'react';
import { Outlet } from 'react-router-dom';

import { ApplicationSettingsApp } from './application-settings-app';
import { AppointmentApp } from './appointment-app';
import { AppointmentV3App } from './appointment-v3-app';
import { CalendarApp } from './calendar-app';
import { CalendarV2App } from './calendar-v2-app';
import { ServicesV2App } from './services-v2-app';
import { SettingsV2App } from './settings-v2-app';
import { ContractApp } from './contract-app';
import { CustomersApp } from './customers-app';
import { LaunchpadApp } from './launchpad-app';
import { LegacyApp } from './legacy-app';
import { UserProfileApp } from './user-profile-app';
import { ResourcesApp } from './resources-app';
import { FeedbackApp } from './feedback-app';
import { RemindersApp } from './reminders-app';
import { LocationsApp } from './locations-app';
import Playground from './playground';

import useServicesSettings from '../src/views/services/use-services-settings';

import { NO_PROPS } from './constants';

const SERVICES_MICRO_SERVICE_COMPONENTS_SCHEMA = [
  ['ServicesList', NO_PROPS],
  ['NewCategory', NO_PROPS],
  ['NewCourse', NO_PROPS],
  ['NewService', NO_PROPS],
  ['EditCategory', { categoryId: { type: String, required: true } }],
  ['EditCourse', { courseId: { type: String, required: true } }],
  ['EditService', { serviceId: { type: String, required: true } }],
];

const settingsAppV2Routes = [
  {
    path: 'settings-v2/booking',
    element: <SettingsV2App mountPath="booking" />,
  },
  {
    path: 'settings-v2/email',
    element: <SettingsV2App mountPath="email" />,
  },
  {
    path: 'settings-v2/company',
    element: <SettingsV2App mountPath="company" />,
  },
  {
    path: 'settings-v2/hours',
    element: <SettingsV2App mountPath="hours" />,
  },
];

const playgroundRoutes = [
  {
    path: '/playground/',
    element: <Outlet />,
    children: [
      {
        path: 'application-settings',
        element: <ApplicationSettingsApp />,
      },
      {
        path: 'appointment',
        element: <AppointmentApp />,
      },
      {
        path: 'appointment-v3',
        element: <AppointmentV3App />,
      },
      {
        path: 'calendar',
        element: <CalendarApp />,
      },
      {
        path: 'calendar-v2',
        element: <CalendarV2App />,
      },
      {
        path: 'contract',
        element: <ContractApp />,
      },
      {
        path: 'customers',
        element: <CustomersApp />,
      },
      {
        path: 'locations',
        element: <LocationsApp />,
      },
      {
        path: 'launchpad',
        element: <LaunchpadApp />,
      },
      {
        path: 'resources',
        element: <ResourcesApp />,
      },
      {
        path: 'feedback',
        element: <FeedbackApp />,
      },
      {
        path: 'reminders',
        element: <RemindersApp />,
      },
      {
        path: 'user-profile',
        element: <UserProfileApp />,
      },
      {
        path: 'services-v2',
        element: <ServicesV2App />,
      },
      {
        path: 'settings-v2',
        element: <SettingsV2App />,
      },
      ...settingsAppV2Routes,
      {
        path: 'services/components',
        element: (
          <Playground
            serviceName="services"
            componentsApiSchema={SERVICES_MICRO_SERVICE_COMPONENTS_SCHEMA}
            useSetupSettingsHook={useServicesSettings}
          />
        ),
      },
      {
        path: ':appName',
        // TODO: We need to modify this component
        element: <LegacyApp />,
      },
    ],
  },
];

export default playgroundRoutes;
